import { useMemo } from 'react';
import Dropdown from '../shared/Dropdown';
import FilterPill from './FilterPill';

export default function KnowledgeFilters({
  searchTerm,
  setSearchTerm,
  selectedProduct,
  setSelectedProduct,
  selectedCategory,
  setSelectedCategory,
  contextFilters,
  onRemoveFilter,
  products = [],
  categories = []
}) {
  // Transform products API data into dropdown options
  const productOptions = useMemo(() => {
    return [
      { value: 'all', label: 'All Products' },
      ...products.map(product => ({
        value: product.name,
        label: product.name
      }))
    ];
  }, [products]);

  // Transform categories API data into dropdown options
  const categoryOptions = useMemo(() => {
    return [
      { value: 'all', label: 'All Categories' },
      ...categories.map(category => ({
        value: category,
        label: category
      }))
    ];
  }, [categories]);

  const clearAll = () => {
    setSearchTerm('');
    setSelectedProduct('all');
    setSelectedCategory('all');
  };

  return (
    <div className="space-y-3">
      {/* Search Bar */}
      <div className="relative">
        <svg
          className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search collections..."
          className="w-full pl-10 pr-10 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-purple-500"
        />
        {searchTerm && (
          <button
            onClick={() => setSearchTerm('')}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-300 transition-colors"
            aria-label="Clear search"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>

      {/* Dropdowns Row */}
      <div className="grid grid-cols-2 gap-2">
        <Dropdown
          value={selectedProduct}
          onChange={(e) => setSelectedProduct(e.target.value)}
          options={productOptions}
          className="!pl-3"
        />

        <Dropdown
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
          options={categoryOptions}
          className="!pl-3"
        />
      </div>

      {/* Context Filter Pills */}
      {contextFilters && contextFilters.length > 0 && (
        <div>
          <div className="grid grid-cols-3 gap-2">
            {contextFilters.map((filter) => (
              <FilterPill
                key={filter.id}
                filter={filter}
                onRemove={onRemoveFilter}
              />
            ))}
          </div>

          {/* Clear All Button */}
          <div className="flex justify-end mt-2">
            <button
              onClick={clearAll}
              className="text-xs text-purple-400 hover:text-purple-300 transition-colors duration-200 underline"
            >
              Clear All
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
